import { NotificationFeedList } from './list/NotificationFeedList';
import { useNotificationsFeedList } from './useNotificationsFeedList';

/**
 * Knock-connected MUI feed list for the sidenav notifications popover.
 */
export function NotificationsFeed() {
  const feed = useNotificationsFeedList();

  return (
    <NotificationFeedList
      items={feed.items}
      unreadCount={feed.unreadCount}
      filter={feed.filter}
      onFilterChange={feed.setFilter}
      onItemClick={feed.onItemClick}
      onArchive={feed.onArchive}
      onButtonClick={feed.onButtonClick}
      onMarkAllAsRead={feed.onMarkAllAsRead}
      hasMore={feed.hasMore}
      isLoading={feed.isLoading}
      isLoadingMore={feed.isLoadingMore}
      onLoadMore={feed.onLoadMore}
    />
  );
}
